export default "__VITE_ASSET__BuiGk$2U__"